import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const UserGroupState = {
  userGroups: {
    groups: [],
  },
}

export const UserGroupActions = {
  getUserGroups: async ({ commit }, { id }) => {
    return axiosRequest.get(`/users/${id}/user_groups`).
      then(({ data }) => {
        commit('setUserGroups', data)

        return data
      }).
      catch(handleError)
  },
}

export const UserGroupGetters = {
  userGroups: state => state.userGroups.groups,
}

export const UserGroupMutations = {
  setUserGroups: (state, userGroups) => { state.userGroups.groups = userGroups },
}
